/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Role_NoneInputs */

const en_admin_user_create_role_none = /** @type {(inputs: Admin_User_Create_Role_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None (candidate)`)
};

const de_admin_user_create_role_none = /** @type {(inputs: Admin_User_Create_Role_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine (Kandidat)`)
};

/**
* | output |
* | --- |
* | "None (candidate)" |
*
* @param {Admin_User_Create_Role_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_role_none = /** @type {((inputs?: Admin_User_Create_Role_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Role_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_role_none(inputs)
	return en_admin_user_create_role_none(inputs)
});